import { ReactNode, useEffect } from 'react'
import { createPortal } from 'react-dom'

type ModalProps = {
	isOpen: boolean
	onClose: () => void
	title?: string
	children: ReactNode
}

export default function Modal({ isOpen, onClose, title, children }: ModalProps) {
	useEffect(() => {
		if (!isOpen) return
		const onEsc = (e: KeyboardEvent) => {
			if (e.key === 'Escape') onClose()
		}
		document.addEventListener('keydown', onEsc)
		const previousOverflow = document.body.style.overflow
		document.body.style.overflow = 'hidden'
		document.documentElement.classList.add('modal-open')
		return () => {
			document.removeEventListener('keydown', onEsc)
			document.body.style.overflow = previousOverflow
			document.documentElement.classList.remove('modal-open')
		}
	}, [isOpen, onClose])

	if (!isOpen) return null

	const content = (
		<div aria-modal="true" role="dialog" className="fixed inset-0 z-[60] flex items-center justify-center px-4">
			<button aria-label="Close modal" onClick={onClose} className="absolute inset-0 bg-black/50" />
			<div className="relative w-full max-w-md modal-card p-6">
				<div className="flex items-center justify-between">
					<h2 className="text-xl font-semibold text-black">{title}</h2>
					<button onClick={onClose} className="px-2 py-1 rounded text-black hover:bg-black/5">✕</button>
				</div>
				<div className="mt-4">
					{children}
				</div>
			</div>
		</div>
	)

	return createPortal(content, document.body)
}


